module.exports = __webpack_public_path__ + "static/media/credit13.5bf1bfb0.png";